import { render, staticRenderFns } from "./AboutSix.vue?vue&type=template&id=6477b59c&"
import script from "./AboutSix.vue?vue&type=script&lang=js&"
export * from "./AboutSix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports